import img1 from "../images/contact/national-railway-museum.jpg";
import img2 from "../images/contact/visit-york.jpg";
import img3 from "../images/contact/north-yorkshire-moors-railway-nymr.jpg";
import img4 from "../images/contact/yorkshire-coast.jpg";
import img5 from "../images/contact/castle-howard.jpg";
import img6 from "../images/contact/eden-camp.jpg";

const imgArray = [
  {
    src: img1,
    name: "National Railway Museum",
    url: "https://www.yorkshire.com/places/yorkshire-coast",
    excerpt: ""
  },
  {
    src: img2,
    name: "Visit York",
    url: "https://www.yorkshire.com/places/yorkshire-coast",
    excerpt: ""
  },
  {
    src: img3,
    name: "North Yorkshire Moors Railway (NYMR)",
    url: "https://www.yorkshire.com/places/yorkshire-coast",
    excerpt: ""
  },
  {
    src: img4,
    name: "Yorkshire Coast",
    url: "https://www.yorkshire.com/places/yorkshire-coast",
    excerpt: ""
  },
  {
    src: img5,
    name: "Castle Howard",
    url: "https://www.yorkshire.com/places/yorkshire-coast",
    excerpt: ""
  },
  {
    src: img6,
    name: "Eden Camp",
    url: "https://www.yorkshire.com/places/yorkshire-coast",
    excerpt: ""
  }
];

const textArray = {
  text:
    "Classic & Sportscar Centre is based in one of the most beautiful areas of England. If you're coming to view one of our cars why not take the chance to enjoy some of our local sights."
};

export { imgArray, textArray };
